import { TeamInvitationState, TeamRole } from '@anm/api/modules/team';
import ActionsDropdown, { Action } from '@anm/components/ActionsDropdown';
import getFromCdn from '@anm/helpers/getFromCdn';
import { capitalize } from 'lodash/fp';
import { FC } from 'react';
import { UserTeamPermission } from 'types/user';

import { ActionsDropdownContainer, Email, ImageWrapper, Role, Status, UserName } from './Wrapper';

export type InvitationItemInputProps = {
  email: string;
  role: TeamRole;
  userName: string;
  isTeamMember: boolean;
  permissions?: UserTeamPermission;
  userId?: string;
  avatar?: string;
  inviteKey?: string;
  inviteStatus?: TeamInvitationState;
};
type InvitationItemProps = InvitationItemInputProps & {
  onChange: (id: string) => void;
  onUserDelete: (id: string) => void;
  onInviteResend: (id: string) => void;
  onInviteDelete: (id: string) => void;
};

const InvitationItem: FC<InvitationItemProps> = ({
  userId,
  inviteKey,
  avatar,
  email,
  inviteStatus,
  permissions,
  role,
  userName,
  isTeamMember,
  onChange,
  onUserDelete,
  onInviteResend,
  onInviteDelete
}) => {
  const { canChangeOwner, canRemove, canGrantAdmin, canGrantNonAdmin } = permissions || {};
  const canShowDropdown = !isTeamMember || canChangeOwner || canGrantAdmin || canGrantNonAdmin || canRemove;

  const handleChange = () => {
    userId && onChange(userId);
  };
  const handleUserDelete = () => {
    userId && onUserDelete(userId);
  };
  const handleInviteDelete = () => {
    inviteKey && onInviteDelete(inviteKey);
  };
  const handleInviteResend = () => {
    inviteKey && onInviteResend(inviteKey);
  };

  return (
    <>
      <div>{avatar && <ImageWrapper src={avatar} />}</div>
      <div>
        <UserName>{userName}</UserName>
        {inviteStatus && <Status variant={inviteStatus} />}
      </div>
      <Email>{email}</Email>
      <Role>{capitalize(role)}</Role>
      <ActionsDropdownContainer>
        {role !== 'OWNER' && canShowDropdown && (
          <ActionsDropdown
            autoClose={true}
            actions={
              isTeamMember
                ? ([
                    (canChangeOwner || canGrantAdmin || canGrantNonAdmin) && {
                      icon: getFromCdn('images/dashboard/admin.svg'),
                      name: 'Change role',
                      handler: handleChange
                    },
                    canRemove && {
                      icon: getFromCdn('images/dashboard/delete.svg'),
                      name: 'Delete member',
                      handler: handleUserDelete
                    }
                  ].filter(Boolean) as Action[])
                : [
                    {
                      icon: getFromCdn('images/icons/share_arrow.svg'),
                      name: 'Resend invite',
                      handler: handleInviteResend
                    },
                    {
                      icon: getFromCdn('images/dashboard/delete.svg'),
                      name: 'Delete invite',
                      handler: handleInviteDelete
                    }
                  ]
            }
          />
        )}
      </ActionsDropdownContainer>
    </>
  );
};

export default InvitationItem;
